const urlForUser = ({ uid, userName, isActivated, prefix }) => {
	let userUrl = (userName ? `${isActivated ? '/user' : '/userprofile'}/${userName}` : `${isActivated ? '/user' : '/userprofile'}/?uid=${uid}`)
	if (prefix) {
		userUrl = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + userUrl
	}
	return userUrl
}

export default urlForUser



// WEBPACK FOOTER //
// ./src/utilities/urlForUser.js